import { createReducer } from '@reduxjs/toolkit';
import { ProjectDto } from '../../api/ClientApi';

import { saveProject, importProjects, updateReduxProject } from '../actions/projectActions';
import { addNewProjectForClientDetails } from '../actions/clientActions';

export interface ProjectsReducerState {
    projects: ProjectDto[] | null;
}

function clearState(state: ProjectsReducerState): void {
    state.projects = null;
}

function getInitialState(): ProjectsReducerState {
    const state: ProjectsReducerState = {
        projects: null,
    };

    clearState(state);

    return state;
}

export const projectsReducer = createReducer<ProjectsReducerState>(getInitialState(), (builder) => {
    builder
        .addCase(addNewProjectForClientDetails, (state: ProjectsReducerState, action: any) => {
            if (state.projects === null) {
                return;
            }

            const payload: ProjectDto = action.payload;

            state.projects.unshift(payload);
        })
        .addCase(saveProject.fulfilled, (state: ProjectsReducerState, action: any) => {
            if (state.projects === null) {
                return;
            }

            const payload: ProjectDto = action.payload;

            const project: ProjectDto = new ProjectDto();
            project.init(payload);

            const projectIndex = state.projects!.findIndex((a) => {
                return a.id === project.id;
            });

            if (projectIndex >= 0) {
                // update project
                state.projects.splice(projectIndex, 1, project);
            } else {
                // add project
                state.projects.unshift(project);
            }
        })
        .addCase(importProjects.fulfilled, (state: ProjectsReducerState, action: any) => {
            const newProjects = (action.payload ?? []) as ProjectDto[];

            state.projects = newProjects.sort((a, b) => (b.id ?? 0) - (a.id ?? 0));
        })
        .addCase(updateReduxProject.fulfilled, (state: ProjectsReducerState, action: any) => {
            if (state.projects === null) {
                return;
            }

            const payload: ProjectDto = action.payload;

            const project: ProjectDto = new ProjectDto();
            project.init(payload);

            const projectIndex = state.projects!.findIndex((a) => {
                return a.id === project.id;
            });

            if (projectIndex >= 0) {
                // update project
                state.projects.splice(projectIndex, 1, project);
            } else {
                // add project
                state.projects.unshift(project);
            }
        });
});
